import { Injector, OnDestroy, Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export abstract class BaseUnsubscribe implements OnDestroy {
  protected readonly unsubscribe$ = new Subject<void>();
  constructor(protected readonly injector: Injector) {}

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
